import React, { createContext, useContext, useState } from 'react';

const UploadSlidesOpenedAtContext = createContext<number | null>(null);

/**
 * Epoch milliseconds (browser clock) of the moment the Add slides modal was last opened,
 * or null while it is closed. A reopened modal gets a fresh timestamp.
 */
export const useUploadSlidesOpenedAtState = (isOpen: boolean): number | null => {
  const [openedAt, setOpenedAt] = useState<number | null>(() => (isOpen ? Date.now() : null));
  const [wasOpen, setWasOpen] = useState(isOpen);

  if (isOpen !== wasOpen) {
    setWasOpen(isOpen);
    setOpenedAt(isOpen ? Date.now() : null);
  }

  return openedAt;
};

export const UploadSlidesOpenedAtProvider = ({
  openedAt,
  children,
}: React.PropsWithChildren<{ openedAt: number | null }>) => (
  <UploadSlidesOpenedAtContext.Provider value={openedAt}>{children}</UploadSlidesOpenedAtContext.Provider>
);

export const useUploadSlidesOpenedAt = () => useContext(UploadSlidesOpenedAtContext);
